import { StoreAttributesSectionProps } from './store-attributes-section.types'
import styles from './store-attributes-section.module.scss'
import cl from 'classnames'
import {
  Button,
  H2,
  IconEdit,
  IconExpand,
  NoneLabel,
  SectionContainer,
  Text2
} from '@touche-lts/panel-ui/dist'
import { StoreAttributeGroup } from './store-attribute-group'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { IconInfoSmall } from 'assets/icons'

const StoreAttributesSectionComponent = (
  props: StoreAttributesSectionProps
) => {
  const { className, style } = props
  const {
    storeAttributesStore: {
      haveAttributeGroups,
      attributeGroups,
      editMode,
      onCancelEditClick,
      onEditButtonClick,
      onSaveClick,
      onAddAttributeGroupClick
    }
  } = useRootStore()

  return (
    <SectionContainer
      colorPreset='dark'
      className={cl(styles.container, className)}
      style={style}
    >
      <H2 colorPreset='dark' className={styles.heading}>
        Store Available Attributes{' '}
        {editMode ? (
          <div className={styles.headingButtonsContainer}>
            <Button
              preset='secondary'
              colorPreset='dark'
              onClick={onCancelEditClick}
            >
              Cancel
            </Button>
            <Button preset='primary' onClick={onSaveClick}>
              Save
            </Button>
          </div>
        ) : (
          <Button preset='icon' onClick={onEditButtonClick}>
            <IconEdit fill={styles.white} />
          </Button>
        )}
      </H2>
      {haveAttributeGroups ? (
        <div>
          {editMode && (
            <div className={styles.attributeLineChildren}>
              <Text2
                colorPreset='dark'
                bold
                className={styles.labelWithInfoIcon}
              >
                Attribute
                <IconInfoSmall title='Some info about Attribute' />
              </Text2>
              <Text2 colorPreset='dark' bold>
                Type
              </Text2>
              <Text2
                colorPreset='dark'
                bold
                className={styles.labelWithInfoIcon}
              >
                Values
                <IconInfoSmall title='Some info about Value' />
              </Text2>
            </div>
          )}
          {attributeGroups.map(attributeGroup => {
            return (
              <>
                <StoreAttributeGroup
                  key={attributeGroup.id}
                  attributeGroup={attributeGroup}
                />
              </>
            )
          })}
        </div>
      ) : (
        <NoneLabel colorPreset='dark' label='No attributes added yet' />
      )}

      <Button
        preset='link'
        style={{ marginTop: 30 }}
        onClick={onAddAttributeGroupClick}
      >
        <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
        Add{haveAttributeGroups && ' another'} attribute
      </Button>
    </SectionContainer>
  )
}

const StoreAttributesSection = observer(StoreAttributesSectionComponent)
export { StoreAttributesSection }
